<!-- all-alerts popup (on view alerts button of alert notification popup) -->
<div class="popup-bg ">
    <div class="popup all-alerts-popup">
        <div class="popup-content">
            <h3>custom-alert</h3>
            <ng-scrollbar>
                <div class="popup-tabling">
                    <ul class="alert-listing">
                        <li class="alert-listing-head">
                            <span class="app-text app-name">Name</span>
                            <span class="app-text app-name">KPI</span>
                            <span class="app-text app-kpi">Condition</span>
                            <span class="app-text app-value">Value</span>
                            <span class="app-text app-type">Application</span>
                            <!-- <span class="app-text app-time">Time</span> -->
                            <span class="app-text use-date">Date</span>
                        </li>
                        <li class="alert-listing-data" *ngFor="let alert of alertList;">
                            <span class="app-text app-name">{{alert['alertName']}}</span>
                            <span class="app-text app-kpi">{{alert['scoreName']}}</span>
                            <span class="app-text app-kpi">{{alert['scoreCondition']}}</span>

                            <span class="app-text app-value">{{alert['value']}}</span>
                            <span class="app-text app-type">{{alert['appname']}}</span>
                            <!-- <span class="app-text app-time">{{alert['updatedtime']}}</span> -->
                            <span class="app-text use-date">{{alert['startDate'] +'&nbsp;to&nbsp;'+alert['endDate']}}</span>

                            <span class="table-options">
                            <span class="edit-icon" (click)="forPopupOpen(alert,'editAlert')"></span>
                            <span class="remove-icon" (click)="delete(alert['alertId'])"></span>
                            </span>
                        </li>

                    </ul>
                    <div *ngIf="alertList.length==0" class="no-data">
                        <span>No Data found.</span>
                    </div>
                </div>
            </ng-scrollbar>
            <div class="popup-links text-right">
                <a href="javascript:void(0)" class="btn btn-light" (click)='forPopupClose()'>Close</a>
                <a href="javascript:void(0)" class="btn btn-dark" (click)="forPopupOpen('','AddNewAlert')">Add new alert</a>
            </div>
        </div>
    </div>
</div>